import { useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Skeleton from 'react-loading-skeleton';
import styles from '@components/ProductCardNew/ProductImage/ProductImage.styles';
import { IProductPackshots } from '@features/categories/typescript';
import { NUM_OF_PACKSHOTS } from '@features/categories/const';
import PackshotImage from '@components/ProductCardNew/ProductImage/PackshotImage/PackshotImage';
import PackshotVideo from '@components/ProductCardNew/ProductImage/PackshotVideo/PackshotVideo';
import PackshotImageHover from '@components/ProductCardNew/ProductImage/PackshotImageHover/PackshotImageHover';
type PropsType = {
  packshots: IProductPackshots;
  alt: string;
  setIsLoading: (isLoading) => void;
  isSmall: boolean;
  isSlider: boolean;
};
const ProductImage = ({
  packshots,
  alt,
  setIsLoading = () => null,
  isSmall,
  isSlider
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const [standardLoaded, setStandardLoaded] = useState(false);
  const [showPlaceholder, setPlaceholder] = useState(false);
  const {
    main: mainPackshots,
    hover: hoverPackshots,
    mainShadow,
    mainVideo,
    hoverVideo,
    hoverOpened
  } = packshots;
  const onLoadFunc = () => {
    setStandardLoaded(true);
    setIsLoading(false);
  };
  const onErrorFunc = () => {
    setStandardLoaded(false);
    setPlaceholder(true);
    setIsLoading(false);
  };
  const getPoster = () => {
    if (mainShadow.length) {
      return mainShadow[0].url;
    }
    if (mainPackshots.length) {
      return mainPackshots[0].url;
    }
    return '';
  };
  const renderMainImage = useMemo(() => {
    if (mainVideo.length) {
      return mainVideo.slice(0, NUM_OF_PACKSHOTS).map(video =>
      // @ts-expect-error - React 19 compatibility issue with memo types
      <PackshotVideo key={video.code} url={video.url} poster={getPoster()} onLoadFunc={onLoadFunc} onErrorFunc={onErrorFunc} />);
    }
    if (mainShadow.length) {
      return mainShadow.slice(0, NUM_OF_PACKSHOTS).map(packshot =>
      // @ts-expect-error - React 19 compatibility issue with memo types
      <PackshotImage key={packshot.code} url={packshot.url} alt={alt} showPlaceholder={showPlaceholder} onLoadFunc={onLoadFunc} onErrorFunc={onErrorFunc} standardLoaded={standardLoaded} isBig />);
    }
    if (mainPackshots.length) {
      return mainPackshots.slice(0, NUM_OF_PACKSHOTS).map(packshot =>
      // @ts-expect-error - React 19 compatibility issue with memo types
      <PackshotImage key={packshot.code} url={packshot.url} alt={alt} onLoadFunc={onLoadFunc} onErrorFunc={onErrorFunc} showPlaceholder={showPlaceholder} isSlider={isSlider} isSmall={isSmall} standardLoaded={standardLoaded} />);
    }
    return (
      // @ts-expect-error - React 19 compatibility issue with memo types
      <PackshotImage url="" alt="" onLoadFunc={onLoadFunc} onErrorFunc={onErrorFunc} showPlaceholder isSlider={isSlider} isSmall={isSmall} standardLoaded={false} />
    );
  }, [mainPackshots, mainVideo, mainShadow, standardLoaded, showPlaceholder]);
  const renderHover = useMemo(() => {
    if (hoverVideo.length) {
      return hoverVideo.slice(0, NUM_OF_PACKSHOTS).map(video =>
      // @ts-expect-error - React 19 compatibility issue with memo types
      <PackshotVideo key={video.code} url={video.url} isHover />);
    }
    if (hoverPackshots.length) {
      return hoverPackshots.slice(0, NUM_OF_PACKSHOTS).map(hover =>
      // @ts-expect-error - React 19 compatibility issue with memo types
      <PackshotImageHover key={hover.code} alt={`${alt} ${t('arrangement.single')}`} url={hover.url} />);
    }
    if (hoverOpened.length) {
      return hoverOpened.slice(0, NUM_OF_PACKSHOTS).map(hover =>
      // @ts-expect-error - React 19 compatibility issue with memo types
      <PackshotImageHover key={hover.code} alt={`${alt} ${t('arrangement.single')}`} url={hover.url} isOpened isSmall={isSmall} isSlider={isSlider} />);
    }
    return null;
  }, [hoverOpened, hoverPackshots, hoverVideo]);
  return <>
      {!standardLoaded && !showPlaceholder && <Skeleton count={1} sx={styles.mainImageSkeleton} enableAnimation />}
      <div sx={styles.visualContainer}>
        {renderMainImage}
        {renderHover}
      </div>
    </>;
};
export default ProductImage;